/** Human-readable plan names for billing badge + UI. */
const PLAN_LABELS = {
  trial: "Trial",
  founder: "Founder",
  growth: "Growth",
  enterprise: "Enterprise",
  starter: "Starter",
  pro: "Pro",
};

export function planDisplayLabel(planId) {
  if (!planId) return "Trial";
  const key = String(planId).toLowerCase();
  return PLAN_LABELS[key] || key.charAt(0).toUpperCase() + key.slice(1);
}

export function paidPlanBadgeLabel(planId, planLabelFromApi) {
  const name = planLabelFromApi || planDisplayLabel(planId);
  return `${name} · paid`;
}
